import { StepAction } from '../../../types/RequirementSteps.types';
import { RequirementEvidenceUrl } from './RequirementEvidenceUrl';
import { RequirementEvidenceAttestation } from './RequirementEvidenceAttestation';
import { RequirementEvidenceDocument } from './RequirementEvidenceDocument';

type RequirementEvidenceControlProps = {
  action: StepAction;
  onSubmitted: () => void;
  // Document evidence only: opens the upload dialog, which RequirementListStep owns (see
  // RequirementEvidenceDocumentModal for why it cannot live inside the drawer).
  onRequestUpload: (action: StepAction) => void;
  // Label for the document upload button — "Renew" for an obligation inside its renewal window.
  uploadLabel?: string;
  // Passed through to the document control: when false the step hoists the button to its footer.
  showUploadButton?: boolean;
};

// Renders the evidence control for a single action based on its `evidenceKind`.
// Only used for pack-driven (non-EU) actions that carry an `evidenceKind`.
export function RequirementEvidenceControl({
  action,
  onSubmitted,
  onRequestUpload,
  uploadLabel,
  showUploadButton = true
}: RequirementEvidenceControlProps) {
  const submittedEvidence = action.submittedEvidence ?? undefined;

  switch (action.evidenceKind) {
    case 'url':
      return (
        <RequirementEvidenceUrl
          actionId={action.id}
          submittedEvidence={submittedEvidence}
          onSubmitted={onSubmitted}
        />
      );
    case 'attestation':
      return (
        <RequirementEvidenceAttestation
          actionId={action.id}
          submittedEvidence={submittedEvidence}
          onSubmitted={onSubmitted}
        />
      );
    // `document` and any not-yet-wired kind fall back to document upload.
    case 'document':
    default:
      return (
        <RequirementEvidenceDocument
          submittedEvidence={submittedEvidence}
          uploadLabel={uploadLabel}
          showUploadButton={showUploadButton}
          onRequestUpload={() => onRequestUpload(action)}
        />
      );
  }
}
